// *************************************
// ************* BG Curves *************
// *************************************

import { siteSettings } from '../../js/global';

import './bg-curves.scss';

const thresholdArray = [];
for(let x = 0; x <= 1; x += .05) thresholdArray.push(x);

class BgCurves {

    constructor(el, index) {
        if(siteSettings.reducedMotionPref) {
            el.classList.remove('bg-curves');
        } else {
            this.el = el;
            this.artwork = this.el.querySelector('.bg-curves--decor--inner');
            this.index = index;
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) this.update(entry);
                });
            },{threshold: thresholdArray});
            // slight delay before observing
            setTimeout(() => {
                this.observer.observe(this.el);
            },200);
        }
    }

    update(entry) {
        const ratio = entry.intersectionRatio,
            ir = entry.intersectionRect;
        if(ratio > .8 || ir.height >= (window.innerHeight * .5)) {
            this.artwork.classList.add('animate');
            this.observer.unobserve(this.el);
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new BgCurves(node);
        }
    });
}